(() => {
  const SECTION_SELECTOR = '[data-featured-case-study]';
  const VALUE_SELECTOR = '.featured-case-study__stat-value';
  const DURATION_MS = 1400;
  const OBSERVER_OPTIONS = {
    threshold: 0.35,
  };

  const prefersReducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const easeOutCubic = (progress) => 1 - Math.pow(1 - progress, 3);

  const getPrecision = (valueText) => {
    const decimalPart = valueText.split('.')[1];
    return decimalPart ? decimalPart.length : 0;
  };

  const formatValue = (value, precision) => {
    if (precision > 0) {
      return value.toFixed(precision);
    }

    return String(Math.round(value));
  };

  const animateValue = (element) => {
    if (!(element instanceof Element) || element.dataset.counterAnimated === 'true') {
      return;
    }

    const targetText = element.textContent.trim();
    const targetValue = Number(targetText);

    if (!Number.isFinite(targetValue)) {
      element.dataset.counterAnimated = 'true';
      return;
    }

    const precision = getPrecision(targetText);
    element.dataset.counterAnimated = 'true';

    if (prefersReducedMotion()) {
      element.textContent = formatValue(targetValue, precision);
      return;
    }

    const startTime = performance.now();

    const tick = (currentTime) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / DURATION_MS, 1);
      const currentValue = targetValue * easeOutCubic(progress);

      element.textContent = formatValue(currentValue, precision);

      if (progress < 1) {
        window.requestAnimationFrame(tick);
        return;
      }

      element.textContent = formatValue(targetValue, precision);
    };

    element.textContent = formatValue(0, precision);
    window.requestAnimationFrame(tick);
  };

  const animateSection = (section) => {
    section.querySelectorAll(VALUE_SELECTOR).forEach((valueElement) => animateValue(valueElement));
  };

  const observeSection = (section) => {
    if (!(section instanceof Element) || section.dataset.counterObserverAttached === 'true') {
      return;
    }

    const statValues = section.querySelectorAll(VALUE_SELECTOR);
    if (!statValues.length) {
      return;
    }

    if (!('IntersectionObserver' in window)) {
      animateSection(section);
      section.dataset.counterObserverAttached = 'true';
      return;
    }

    const observer = new IntersectionObserver((entries, intersectionObserver) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          return;
        }

        animateSection(section);
        intersectionObserver.unobserve(entry.target);
      });
    }, OBSERVER_OPTIONS);

    observer.observe(section);
    section.dataset.counterObserverAttached = 'true';
  };

  const initFeaturedCaseStudyCounters = (root = document) => {
    if (root instanceof Element && root.matches(SECTION_SELECTOR)) {
      observeSection(root);
    }

    if (root.querySelectorAll) {
      root.querySelectorAll(SECTION_SELECTOR).forEach((section) => observeSection(section));
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initFeaturedCaseStudyCounters());
  } else {
    initFeaturedCaseStudyCounters();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initFeaturedCaseStudyCounters(event.target instanceof Element ? event.target : document);
  });
})();